module.exports = {"payments":[{"name":"Cash","value":"cash"},{"name":"Check","value":"check"},{"name":"Credit Card","value":"card"},{"name":"VIPatron","value":"vipatron"},{"name":"Reserved","value":"reserved"},{"name":"Bulk Ticket","value":"bulk"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/PaymentOptions/locales/fr.json
// module id = 1147
// module chunks = 0